// Pattern validation for emails, pulled from Angular email validator
export const REGEX_EMAIL = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
export const MEDIA_QUERY_DESKTOP = '@media (any-hover: hover)'
export const WIDTH_PX_APP_DRAWER = 240
export const BREAKPOINT_APP_DRAWER = 'sm'
